import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "header-style",
  class extends Controller {
    static targets = ["logo"]
    static values = {
      defaultColor: { type: String, default: "black" },
    }

    connect() {
      this.currentColor = null
      this.updateColor = this.updateColor.bind(this)

      window.addEventListener("scroll", this.updateColor, { passive: true })

      setTimeout(() => this.updateColor(), 50)
    }

    disconnect() {
      window.removeEventListener("scroll", this.updateColor)
    }

    updateColor() {
      if (!this.hasLogoTarget) return

      const isMobile = window.innerWidth < 768
      const selector = isMobile
        ? "[data-header-text-color], [data-header-text-color-mobile]"
        : "[data-header-text-color]"
      const elements = document.querySelectorAll(selector)
      const detectionZone = window.innerHeight * 0.1

      let topmostElement = null
      let topmostTop = Infinity

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect()
        if (rect.top < detectionZone && rect.bottom > 0) {
          if (rect.top < topmostTop) {
            topmostTop = rect.top
            topmostElement = element
          }
        }
      })

      let newColor = this.defaultColorValue
      if (topmostElement) {
        newColor = isMobile && topmostElement.dataset.headerTextColorMobile
          ? topmostElement.dataset.headerTextColorMobile
          : topmostElement.dataset.headerTextColor || this.defaultColorValue
      }

if (newColor !== this.currentColor) {
  this.logoTarget.classList.remove("text-black", "text-white")
  this.logoTarget.classList.add(`text-${newColor}`)

  const inlineNav = document.querySelector(".psyche-inline-nav")

  if (inlineNav) {
    inlineNav.classList.remove("is-white", "is-black")
    inlineNav.classList.add(`is-${newColor}`)
  }

  this.currentColor = newColor
}
    }
  },
)
